import type { ImageType } from "~/components/common/images";
import Image from "~/components/common/images";

export interface TestimonialSectionProps {
  id: string;
  type: string;
  title: string;
  testimonials: {
    name: string;
    message: string;
    id: string;
    workplace: string;
    award: string;
    image?: ImageType;
  }[];
}

const TestimonialSection = ({
  type,
  title,
  testimonials,
}: TestimonialSectionProps) => (
  <section
    id={type}
    className={`section-padding-x bg-purple pb-[60px] pt-[40px] md:pb-[90px] md:pt-[68px]`}
  >
    <h2 className="h2 mb-[60px] text-center text-white">{title}</h2>
    <div className="grid auto-rows-auto gap-[28px] lg:grid-cols-2">
      {testimonials.map((testimonial) => (
        <div
          key={testimonial.id}
          className="rounded-lg border border-solid border-white p-[20px] text-white md:px-[45px] md:py-[50px]"
        >
          <p className="mx-auto mb-[45px] block text-center text-md font-medium italic leading-[140%] md:max-w-[75%] md:text-lg">{`"${testimonial.message}"`}</p>
          <div className="flex items-start gap-[25px]">
            <div className="size-[70px] shrink-0 overflow-hidden rounded-full border-2 border-white md:size-[100px] 2xl:size-[150px]">
              {testimonial.image && (
                <Image
                  image={testimonial.image}
                  alt={testimonial.name}
                  maxWidth={150}
                  className="size-full"
                />
              )}
            </div>
            <div className="pt-[15px] 2xl:max-w-[51%] 2xl:pt-[30px]">
              <div className="text-xs font-semibold uppercase text-[#C2B9F1] md:text-base">{`${testimonial.name} | ${testimonial.workplace}`}</div>
              <div className="mt-[15px] text-xs font-medium text-[#C2B9F1] md:mt-[25px] md:text-base">
                {testimonial.award}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default TestimonialSection;
